export default __webpack_public_path__ + "static/media/Animals-06.0c71cc28.png";